import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {faArrowLeft, faArrowRight} from "@fortawesome/free-solid-svg-icons";
import { v4 as uuidv4 } from 'uuid';
import {Params} from "@angular/router";

export interface PageEvent {
    start: number,
    limit: number,
    length: number,
    activePage: number,
    pages: any[],
    countPages: number
}

@Component({
    selector: 'iw-shop-core-paginator',
    standalone: false,
    templateUrl: './paginator.component.html',
    styleUrls: ['./paginator.component.scss']
})

export class PaginatorComponent implements OnInit, OnChanges {
    @Input() start: number = 0;
    @Input() limit: number = 0;
    @Input() length: number = 0;
    @Input() labelSingle: string = 'Eintrag';
    @Input() labelPlural: string = 'Einträge';
    @Input() ariaLabel?: string;
    @Input() ssrRouterLink?: string;
    @Input() ssrRouterLinkQueryParams?: Params | undefined | null;
    @Output() onChange: EventEmitter<PageEvent> = new EventEmitter();

    pageEvent: PageEvent = {start: 0, limit: 0, length: 0, activePage: 0, countPages: 0, pages: []};

    constructor() {
        if (!this.ariaLabel) {
            this.ariaLabel = 'Navigation-' + uuidv4();
        }



    }

    ngOnChanges(changes: SimpleChanges) {
        this.init();
    }

    ngOnInit(): void {
        this.init();

    }

    init(){
        this.pageEvent.length = this.length;
        this.pageEvent.limit = this.limit;
        this.pageEvent.start = this.start;

        this.pageEvent.activePage = 1;
        this.pageEvent.countPages = 0;
        if (this.limit != 0 &&
            this.length != 0) {
            this.pageEvent.activePage = Math.ceil(this.start / this.limit) + 1;
            this.pageEvent.countPages = Math.ceil(this.length / this.limit);
        }

        this.pageEvent.pages = [];

        const showPageBeforeAndAfter = 2;
        for (let i = 1; i <= this.pageEvent.countPages; i++) {
            if (
                i >= (this.pageEvent.activePage - showPageBeforeAndAfter) &&
                i <= (this.pageEvent.activePage + showPageBeforeAndAfter)) {
                this.pageEvent.pages.push(i);
                continue;
            }

            if (i == (this.pageEvent.activePage - showPageBeforeAndAfter - 1)) {
                this.pageEvent.pages.push(1);
                if (i !== 1) {
                    this.pageEvent.pages.push('...');
                }
            }

            if (i == (this.pageEvent.activePage + showPageBeforeAndAfter + 1)) {
                if (i != this.pageEvent.countPages) {
                    this.pageEvent.pages.push('...');
                }

                this.pageEvent.pages.push(this.pageEvent.countPages);
            }
        }
    }

    setPage(activePage: number) {
        this.pageEvent.start = ( (activePage-1) * this.pageEvent.limit);
        this.pageEvent.activePage = activePage;
        this.onChange.emit(this.pageEvent);
    }

    getSSRRouterLink(page: number){
        if(!this.ssrRouterLink){
            return null;
        }
        return this.ssrRouterLink.replace('{page}', page.toString());
    }

    getSSRRouterLinkQueryParams(){
        if(!this.ssrRouterLinkQueryParams){
            return null;
        }
        return this.ssrRouterLinkQueryParams;
    }

    protected readonly faArrowLeft = faArrowLeft;
    protected readonly faArrowRight = faArrowRight;
}
